import { Card, Image, List, Menu } from "antd";
import React, { Component } from "react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { observer } from "mobx-react";

class GraphsMenus extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      items: [],
      remaining: [],
    };
  }
  handleMenuClick = (items) => {
    this.props.navigate("/" + items);
    this.props.closeMenu();
  };

  async componentDidMount() {
    const items = [
      {
        key: "info",
        type: "group",
        label: (
          <div
            style={{
              padding: "15px",
              color: "#fff",
              backgroundColor: "#002766",
            }}
          >
            <span className="menu-items-title" style={{ gap: 10 }}>
              <img
                src={require("../assets/images/NewDesign/pie-chart-fill.png")}
                alt="Masters"
                style={{ width: "22px" }}
              />
              {this.context.translate("_GRAPH_")}
            </span>

            <p
              style={{
                fontSize: "10px",
                marginTop: "5px",
                color: "rgba(255, 255, 255, 0.8)",

                marginBottom: "0px",
              }}
            >
              {this.context.translate("_GRAPHS_DESC_")}
            </p>
          </div>
        ),
      },
    ];

    const remaining2 = [
      {
        key: "SpeedGraph",
        type: "SpeedGraph",
        label: (
          <div onClick={() => this.handleMenuClick("SpeedGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/pie-chart-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_SPEED_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_SPEED_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "DistanceGraph",
        type: "DistanceGraph",
        label: (
          <div onClick={() => this.handleMenuClick("DistanceGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/graph-up-arrow.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_DISTANCE_GRAPH_")}
            </span>

            <p
              className="submenu-items-desc"
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
            >
              {this.context.translate("_DISTANCE_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "IdleGraph",
        type: "IdleGraph",
        label: (
          <div onClick={() => this.handleMenuClick("IdleGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/graph-down-arrow.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_IDLE_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_IDLE_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "ExIdleGraph",
        type: "ExIdleGraph",
        label: (
          <div onClick={() => this.handleMenuClick("ExIdleGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/bar-chart-steps.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_EXIDLE_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_EXIDLE_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "UsageGraph",
        type: "UsageGraph",
        label: (
          <div onClick={() => this.handleMenuClick("UsageGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/bar-chart-steps.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_USAGE_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_USAGE_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "TempGraph",
        type: "TempGraph",
        label: (
          <div onClick={() => this.handleMenuClick("TempGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/Vector.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_TEMPERATURE_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_TEMPERATURE_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "DashboardGraph",
        type: "DashboardGraph",
        label: (
          <div onClick={() => this.handleMenuClick("DashboardGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/bar-chart-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_DASHBOARD_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_DASHBOARD_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "FuelGraph",
        type: "FuelGraph",
        label: (
          <div onClick={() => this.handleMenuClick("FuelGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/fuel-pump-fill.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_FUEL_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_FUEL_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },

      {
        key: "DriverScoreGraph",
        type: "DriverScoreGraph",
        label: (
          <div onClick={() => this.handleMenuClick("DriverScoreGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/activity.png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />

              {this.context.translate("_DRIVER_SCORE_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_DRIVER_SCORE_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
      {
        key: "MaxSpeedGraph",
        type: "MaxSpeedGraph",
        label: (
          <div onClick={() => this.handleMenuClick("MaxSpeedGraph")}>
            <span className="submenu-items-title" style={{ gap: 10 }}>
              <Image
                src={require("../assets/images/NewDesign/Graph/Vector 300 (Stroke).png")}
                // alt="Masters"
                style={{ width: "14px" }}
              />
              {this.context.translate("_MAX_SPEED_GRAPH_")}
            </span>

            <p
              // style={{
              //   fontSize: "10px",
              //   marginTop: "10px",
              //   color: "rgba(0, 0, 0, 0.8)",
              //   marginBottom: "0px",
              //   textWrap: "auto",
              //   lineHeight: "normal",
              // }}
              className="submenu-items-desc"
            >
              {this.context.translate("_MAX_SPEED_GRAPH_DESC_")}
            </p>
          </div>
        ),
        children: [],
      },
    ];
    var remaining=[];
    for (var i = 0; i < remaining2.length; i++) {
      //console.log(remaining2[i].key);
      if(this.props.graphsManagement.includes(remaining2[i].key)){
        remaining.push(remaining2[i]);
      }
    }
    
    this.setState({ items: items, remaining: remaining });
  }

  render() {
    return (
      <div className="tracking-menu-items">
        <div className="tracking-menu-items-list">
          <Menu
            style={{
              // height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
            }}
            items={this.state.items}
          />
        </div>
        <div
          className="tracking-submenu-items-list"
          // style={{
          //   overflow: "scroll",
          //   boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
          //   height: "70vh",
          //   scrollbarWidth: "none",
          // }}
        >
          <Menu
            className="tracking-list-menu"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              height: "90vh",
              border: "none",
              scrollbarWidth: "none",
              overflow: "scroll",
              boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
              alignContent: "flex-start",
              height: "100%",
            }}
            items={this.state.remaining}
            onMouseLeave={() => this.props.closeMenu()}
          />
        </div>
      </div>
    );
  }
}
GraphsMenus.contextType = StoreContext;
export default observer(withRouter(GraphsMenus));
